import { useEffect, useRef } from "react";

import { Stack, Typography } from "@mui/material";

import { AvailableLoads } from "components/AvailableLoads";
import { ErrorTypography } from "components/ErrorTypography";
import { LoadingWrappedNode } from "components/LoadingWrappedNode";
import { MultiShipmentProjectBookingsTable } from "components/Shipper/components/MultiShipmentProjectBookingsTable";
import {
  useMultiShipmentProjectBookingsAsShipper,
  useShipmentPageContext,
} from "hooks";

interface Props {
  dividerComponent: JSX.Element;
  parentShipmentId: number | undefined;
}
export function ChildShipmentProjectBookingsSection(props: Props) {
  const { dividerComponent, parentShipmentId } = props;
  const { shipment } = useShipmentPageContext();
  const shipmentRef = useRef<undefined | CondensedShipment>();
  const { projectBookings, refetchBookings, loading, error } =
    useMultiShipmentProjectBookingsAsShipper(parentShipmentId);

  useEffect(() => {
    if (
      shipmentRef.current != null &&
      shipmentRef.current.version !== shipment?.version
    ) {
      refetchBookings();
    }
    shipmentRef.current = shipment;
  }, [shipment, refetchBookings]);

  if (
    shipment?.project === undefined ||
    shipment.project == null ||
    shipment.info.type !== "MULTI_SHIPMENT_PROJECT_CHILD"
  ) {
    return null;
  }

  return (
    <Stack direction="column" mb="1rem">
      {dividerComponent}
      <ErrorTypography error={error} />
      <LoadingWrappedNode loading={loading}>
        <Stack direction="column" spacing={2}>
          <Stack direction="row" alignItems="center" spacing={1} mt="1rem">
            <Typography variant="body1">Parent Project:</Typography>
            <a
              target="_blank"
              href={`/shipments/${parentShipmentId}`}
              rel="noreferrer"
            >
              <Typography
                sx={{ textDecoration: "underline blue", color: "blue" }}
              >
                Project {parentShipmentId}
              </Typography>
            </a>
          </Stack>
          <AvailableLoads shipment={shipment} variant="h6" />
          <MultiShipmentProjectBookingsTable
            bookings={projectBookings}
            quotingUnitOfMeasure={shipment.info.quoting_unit_of_measure}
          />
        </Stack>
      </LoadingWrappedNode>
    </Stack>
  );
}
